import type { FC } from 'react';
import { memo } from 'react';
import type { Options } from 'react-markdown';
import ReactMarkdown from 'react-markdown';

export interface MemoizedReactMarkdownProps extends Options {
  isStreaming?: boolean;
}

export const MemoizedReactMarkdown: FC<MemoizedReactMarkdownProps> = memo(
  ReactMarkdown as FC<MemoizedReactMarkdownProps>,
  (prevProps, nextProps) =>
    prevProps.children === nextProps.children && prevProps.isStreaming === nextProps.isStreaming,
);
